<template>
  <div id="page">
    <b-modal
      ok-only
      ref="model_error"
      title="提示"
      @ok="handleOk"
      ok-title="确定"
    >
      <p class="my-4">{{ errorMsg }}</p>
    </b-modal>
    <b-modal ref="model_qs" title="提示" ok-title="确定" ok-only>
      <p>查询状态异常，请联系银行</p>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "BaseQueryAction",
  data() {
    return {
      bankCode: "",
      applyDetail: "",
      errorMsg: "",
      isInner: "",
    };
  },
  mounted: function () {
    this.applyDetail = this.$route.query.applyDetail;
    this.isInner = this.$route.query.isInner;
    // this.bankCode = this.$route.query.bankCode;
    this.toQishangBank(this.applyDetail);
  },
  methods: {
    handleOk: function (bvModalEvt) {
      this.$router.go(-1);
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    toQishangBank: function (bankSerialObj) {
      let newinput = encodeURIComponent(bankSerialObj); //部署需用newinput，本地测试用bankSerialObj
      var that = this;
      var formData = new FormData();
      console.log("isInner->" + this.isInner);
      if ("inner" === this.isInner) {
        //公众号内部跳转到本页面
        formData.append("applyDetail", bankSerialObj);
        formData.append("bankCode", "0085");
      } else {
        //公众号外部跳转到本页面
        formData.append("applyDetail", newinput);
        formData.append("bankCode", "0085");
      }

      axios({
        method: "post",
        url: config.config_qs.getDecodeData,
        data: formData,
      })
        .then(function (response) {
          // console.log(response)
          //{"checkStatus":"0","merchNo":"","mobileNo":"xx","flowNo":"500000000757468"}
          if (response.status == 200) {
            let data = response.data;
            if (data.checkStatus == "2") {
              that.showqsStateMsg();
              return;
            } else if (
              data.checkStatus == "0" ||
              data.checkStatus == "1" ||
              data.checkStatus == "3"
            ) {
              sessionStorage.setItem("entrance", 2);
              that.$router.replace({
                name: "OrderDetails_qs", //OrderList_qs
                params: {
                  ...data,
                },
              });
            }
          } else {
          }
          let dataRes = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    showqsStateMsg: function () {
      this.$refs["model_qs"].show();
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/qishangbank/BaseQueryAction_qs.vue